import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { useMediaQuery } from 'react-responsive';

export default function Banner() {
  const slideData = [
    {
      alt: 'Hytera HP78X',
      btnText: 'PRODUCTOS',
      title: 'Alta Potencia y Ruggedness: Hytera HP78X',
      title_short: 'Hytera HP78X',
      description:
        'La serie HP7 combina audio de 1 W, batería de hasta 16 h y certificación IP67/MIL-STD para ofrecer comunicación fiable en entornos extremos.',
      description_short:
        'Audio potente, 16 h y resistencia IP67/MIL-STD.',
      // URLs de ejemplo; cambia por las tuyas:
      srcDesktop: 'https://jumpseller.s3.eu-west-1.amazonaws.com/store/radioclub/assets/HP78X_Highlights-2.jpg',
      srcTablet: 'https://jumpseller.s3.eu-west-1.amazonaws.com/store/radioclub/assets/HP78X_Highlights-2.jpg',
      srcMobile: 'https://jumpseller.s3.eu-west-1.amazonaws.com/store/radioclub/assets/HP78X_Highlights-2.jpg',
    },
    {
      // PNC370 PoC
      alt: 'Hytera PNC370 PoC',
      btnText: 'PRODUCTOS',
      title: 'Cobertura Global: Hytera PNC370 PoC',
      title_short: 'PNC370 PoC',
      description:
        'Push-to-Talk sobre redes 3G/4G/Wi-Fi, GPS integrado y mensajería de datos, sin necesidad de infraestructura DMR propia.',
      description_short:
        'PTT en 3G/4G/Wi-Fi con GPS.',
      srcDesktop: 'https://img-cdn.hytera.com/iwov-resources/hytera/02_products/2_main_image/LTE_BWC_Emergency/en_PNC370_main.png_n.webp',
      srcTablet: 'https://img-cdn.hytera.com/iwov-resources/hytera/02_products/2_main_image/LTE_BWC_Emergency/en_PNC370_main.png_n.webp',
      srcMobile: 'https://img-cdn.hytera.com/iwov-resources/hytera/02_products/2_main_image/LTE_BWC_Emergency/en_PNC370_main.png_n.webp',
    },
  ];

  const isDesktop = useMediaQuery({ minWidth: 1224 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1224 });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Splide
      options={{
        type: 'loop',
        autoplay: true,
        interval: 3000,
        width: '100%',
      }}
    >
      {slideData.map((slide) => {
        let srcImage;
        if (isDesktop) srcImage = slide.srcDesktop;
        else if (isTablet) srcImage = slide.srcTablet;
        else if (isMobile) srcImage = slide.srcMobile;
        else srcImage = slide.srcDesktop;

        return (
          <SplideSlide key={slide.srcDesktop}>
            <div className="flex flex-col items-center justify-center w-full relative border-gray-600 max-h-[400px] bg-blue-950">
              <img
                src={srcImage}
                alt={slide.alt}
                className="w-full inset-0 object-cover object-center h-full opacity-70"
              />
              <div className="container absolute z-10 flex h-full flex-col md:items-start justify-center w-full md:pb-10 pl-14 md:pl-20">
                <div className="grid grid-cols-5">
                  <h1 className="col-span-5 md:col-span-3 font-bold text-white uppercase leading-snug text-sm md:text-xl lg:text-4xl mb-2 md:mb-4">
                    <span className="hidden sm:block">{slide.title}</span>
                    <span className="block sm:hidden">{slide.title_short}</span>
                  </h1>
                  <div className="col-span-0 md:col-span-2" />
                </div>
                <div className="grid grid-cols-5">
                  <p className="col-span-5 md:col-span-3 text-white text-xs md:text-base lg:text-xl mb-4 pr-24">
                    <span className="hidden sm:block">{slide.description}</span>
                    <span className="block sm:hidden">{slide.description_short}</span>
                  </p>
                  <div className="col-span-0 md:col-span-2" />
                </div>
                <button
                  type="button"
                  onClick={() => { window.location.href = '/productos'; }}
                  className="bg-white text-blue-800 rounded-full px-4 md:px-8 py-1 md:py-2 font-bold hover:scale-105 duration-200 text-xs md:text-base lg:text-xl"
                >
                  {slide.btnText}
                </button>
              </div>
            </div>
          </SplideSlide>
        );
      })}
    </Splide>
  );
}
